import axios from "axios";
import { treesActions } from "../../../../../store/slices/trees";
import {
  calculateSelection,
  parseFileTree,
} from "../../../../../store/slices/trees2-utils";
import { workerActions } from "../../../../../store/slices/workers";
import buildPath from "../../../../../utility/misc/buildRemoteSelectionPath";

// TODO TOMORROW: The c365ID is not being passed to the function and the internal structure must be adjusted to be able to deal
// with c365 nd the regular cloner.
const clonerHandlers = {
  getGreylist: ":5107/repo/greylist/get",
  getFiles: ":5107/files",
};

const cloner365Handlers = {
  getGreylist: ":5111/remote/repo/greylist/get",
  getFiles: ":5111/remote/files",
};

const loadRepositoryRoot = (data) => {
  return async (dispatch) => {
    const {
      cpassword: cpass,
      path,
      repository: id,
      server,
      M365server,
      tunnelToken: tunnel_token,
      c365ID,
    } = data;
    dispatch(workerActions.start("root" + path));

    let handlers;
    const is365device = !!c365ID;
    if (is365device) {
      handlers = cloner365Handlers;
    } else {
      handlers = clonerHandlers;
    }

    try {
      if (!!id) {
        let url;
        let url2;
        if (is365device) {
          const base = M365server.split(":");
          url = base[0] + ":" + base[1] + handlers.getGreylist;
          url2 = base[0] + ":" + base[1] + handlers.getFiles;
        } else {
          url = server.slice(0, -1) + handlers.getGreylist;
          url2 = server.slice(0, -1) + handlers.getFiles;
        }
        console.log("fetching Greylist!");
        const response = await axios.get(url, {
          headers: { tunnel_token },
          params: { id, cpass },
        });
        const rawGreylist = response.data.selection;

        let greylist = [];
        const rawTreeNode = {
          parentIdx: null,
          rawNodeData: rawGreylist,
        };
        parseFileTree(greylist, rawTreeNode);
        calculateSelection(greylist, 0);

        let nodes = [
          {
            idx: 0,
            parentIdx: null,
            childrenIdx: [],
            isDir: true,
            name: path,
            backup: greylist[0].backup,
            status: 0,
            c365ID: is365device ? c365ID : undefined,
          },
        ];

        // here we check the tree to properly set all nodes backmodes. This might need further node downloading
        // if the node backupMode cannot be determined without it
        const setBaseline = async (rIdx, glIdx) => {
          const rNode = nodes.find((x) => x.idx === rIdx);

          if (rNode.backup < 3 && rNode.backup > 0) {
            let path = encodeURIComponent(buildPath(nodes, rNode.idx, true));
            const response = await axios.get(url2, {
              headers: { tunnel_token },
              params: { path: is365device ? rNode.c365ID : path },
            });
            const glChildren = greylist.filter((x) => x.parentIdx === glIdx);
            const children = response.data.children;

            for (const child of children) {
              const glChild = glChildren.find((x) => x.name === child.Name);
              const idx = nodes.length;
              let newChild = {
                idx,
                parentIdx: rIdx,
                name: child.Name,
                isDir: child.IsDir,
                size: child.Size,
                status: child.Status,
                childrenIdx: [],
                c365ID: is365device ? child.C365ID : undefined,
              };
              if (glChild) {
                newChild.backup = glChild.backup;
              } else {
                if (rNode.backup === 2) {
                  newChild.backup = 3;
                } else if (rNode.backup === 1) {
                  newChild.backup = 0;
                } else {
                  console.error("this should not be happening. ever.");
                }
              }
              nodes.push(newChild);
              rNode.childrenIdx.push(newChild.idx);

              if (glChild) {
                await setBaseline(newChild.idx, glChild.idx);
              }
            }
            rNode.loaded = true;
          } else {
            return;
          }
        };

        await setBaseline(0, 0);

        dispatch(treesActions.loadTree({ id: path, tree: nodes }));
      } else {
        console.log("Repository doesnt exist yet!");
        let nodes = [
          {
            idx: 0,
            parentIdx: null,
            childrenIdx: [],
            isDir: true,
            name: path,
            backup: 0,
            status: 0,
            c365ID: is365device ? c365ID : undefined,
          },
        ];
        dispatch(treesActions.loadTree({ id: path, tree: nodes }));
      }
      dispatch(workerActions.finish({ id: "root" + path }));
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id: "root" + path, error: e.message }));
      return;
    }
  };
};

export default loadRepositoryRoot;
